import './scss/pages/product.scss'
import Swiper from 'swiper'
import { Navigation, Thumbs, FreeMode } from 'swiper/modules'

Swiper.use([Navigation, Thumbs, FreeMode])

const slidesImgs = Array.from(
  document.querySelectorAll('.gallery-top .swiper-slide img'),
)
const srcs = slidesImgs.map((img) => img.src)

const galleryThumbs = new Swiper('.gallery-thumbs', {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
  breakpoints: {
    0: { slidesPerView: 2 },
    768: { slidesPerView: 4 },
  },
})

const galleryTop = new Swiper('.gallery-top', {
  spaceBetween: 10,
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: galleryThumbs,
  },
})

document
  .querySelectorAll('.woocommerce div.product form.cart .quantity')
  .forEach(function (qty) {
    if (!qty.querySelector('.qty-decrease')) {
      var dec = document.createElement('button')
      dec.type = 'button'
      dec.className = 'qty-decrease'
      dec.textContent = '−'

      var inc = document.createElement('button')
      inc.type = 'button'
      inc.className = 'qty-increase'
      inc.textContent = '+'

      qty.insertBefore(dec, qty.firstChild)
      qty.appendChild(inc)
    }
  })

document.body.addEventListener('click', function (e) {
  if (!e.target.matches('.qty-decrease, .qty-increase')) return

  var btn = e.target
  var input = btn.parentNode.querySelector('.qty')
  var value = parseInt(input.value) || 1
  var min = parseInt(input.getAttribute('min')) || 1
  var maxAttr = input.getAttribute('max')
  var max = maxAttr ? parseInt(maxAttr) : null

  if (btn.classList.contains('qty-decrease')) {
    if (value > min) input.value = value - 1
  } else {
    var newValue = value + 1
    if (max !== null && newValue > max) newValue = max
    input.value = newValue
  }

  input.dispatchEvent(new Event('change'))
})
